import cx from "clsx";
import { PayoutMethod } from "kreate-common/modules/business-types";
import ButtonSecondary from "kreate-common/modules/kreate-ui/components/ButtonSecondary";
import DropdownMenu from "kreate-common/modules/kreate-ui/components/DropdownMenu";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import { useModalPromises } from "kreate-common/modules/kreate-ui/components/Modal/hoc/withModalPromises";
import Image from "next/image";
import React from "react";
import { MdAdd } from "react-icons/md";

import CardPayoutAccount from "../../components/CardPayoutAccount";

import styles from "./index.module.scss";

import pngBankTransfer from "@/modules/kreate-modals/modals/ModalPayoutAccount/assets/bank-transfer.png";
import pngCrypto from "@/modules/kreate-modals/modals/ModalPayoutAccount/assets/crypto.png";
import pngMomo from "@/modules/kreate-modals/modals/ModalPayoutAccount/assets/momo.png";
import ModalPayoutAccount$BankTransfer$Add from "@/modules/kreate-modals/modals/ModalPayoutAccount/components/BankTransfer$Add";
import ModalPayoutAccount$Crypto$Add from "@/modules/kreate-modals/modals/ModalPayoutAccount/components/Crypto$Add";
import ModalPayoutAccount$Momo$Add from "@/modules/kreate-modals/modals/ModalPayoutAccount/components/Momo$Add";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  payoutMethods: PayoutMethod[] | null | undefined;
};

export default function TabPayouts({ className, style, payoutMethods }: Props) {
  const { showModal } = useModalPromises();
  return (
    <div className={cx(styles.container, className)} style={style}>
      <Flex.Col gap="24px">
        <h2 className={styles.heading}>{"Payout Methods"}</h2>
        <Flex.Row flexWrap="wrap" gap="16px">
          {payoutMethods?.length ? (
            payoutMethods.map((item, index, array) => (
              <CardPayoutAccount
                key={index}
                value={item}
                array={array}
                index={index}
              />
            ))
          ) : (
            <p className={styles.textNoAccounts}>{"No accounts"}</p>
          )}
        </Flex.Row>
        <Flex.Cell>
          <DropdownMenu.Menu
            trigger={
              <ButtonSecondary icon={<MdAdd />} content="Add Payout Method" />
            }
          >
            <DropdownMenu.Item
              className={styles.dropdownItem}
              content={
                <div className={styles.dropdownItemContent}>
                  <Image
                    className={styles.logo}
                    src={pngMomo}
                    width={24}
                    height={24}
                    alt=""
                  />
                  {"Momo"}
                </div>
              }
              onSelect={() => {
                if (!payoutMethods) return;
                showModal<void>(({ resolve }) => (
                  <ModalPayoutAccount$Momo$Add
                    open
                    onClose={() => resolve()}
                    payoutMethods={payoutMethods}
                  />
                ));
              }}
              disabled={!payoutMethods}
            />
            <DropdownMenu.Item
              className={styles.dropdownItem}
              content={
                <div className={styles.dropdownItemContent}>
                  <Image
                    className={styles.logo}
                    src={pngBankTransfer}
                    width={24}
                    height={24}
                    alt=""
                  />
                  {"Bank Transfer"}
                </div>
              }
              onSelect={() => {
                if (!payoutMethods) return;
                showModal<void>(({ resolve }) => (
                  <ModalPayoutAccount$BankTransfer$Add
                    open
                    onClose={() => resolve()}
                    payoutMethods={payoutMethods}
                  />
                ));
              }}
              disabled={!payoutMethods}
            />
            <DropdownMenu.Item
              className={styles.dropdownItem}
              content={
                <div className={styles.dropdownItemContent}>
                  <Image
                    className={styles.logo}
                    src={pngCrypto}
                    width={24}
                    height={24}
                    alt=""
                  />
                  {"Crypto Wallet"}
                </div>
              }
              onSelect={() => {
                if (!payoutMethods) return;
                showModal<void>(({ resolve }) => (
                  <ModalPayoutAccount$Crypto$Add
                    open
                    onClose={() => resolve()}
                    payoutMethods={payoutMethods}
                  />
                ));
              }}
              disabled={!payoutMethods}
            />
          </DropdownMenu.Menu>
        </Flex.Cell>
      </Flex.Col>
    </div>
  );
}
